import styled, { keyframes } from "styled-components";

const pulsate = keyframes`
  0% {
    transform: scale(0.1, 0.1);
    opacity: 0.0;
  }
  50% {
    opacity: 1.0;
  }
  100% {
    transform: scale(1.2, 1.2);
    opacity: 0.0;
  }
`;

export const RingContainer = styled.div`
  position: relative;
  width: 70px;
  height: 70px;
`;

export const Circle = styled.div`
  width: 15px;
  height: 15px;
  background-color: #1e22ff;
  border-radius: 50%;
  position: absolute;
  top: calc(50% - 7.5px);
  left: calc(50% - 7.5px);
`;

export const RingRing = styled.div`
  border: 3px solid #1e22ff;
  border-radius: 50%;
  height: 25px;
  width: 25px;
  position: absolute;
  top: calc(50% - 12.5px);
  left: calc(50% - 12.5px);
  animation: ${pulsate} 1s ease-out infinite;
  opacity: 0;
`;
